
import {Vue} from "ui.vue";

export let SearchTitle = {
	name: 'SearchTitle',
	data: function () {
		return {
			params: {
				ajaxPage: '',
				minQueryLen: 2,
			},
			query: "",
			result: [],
			resultPage: "",

			loading: false,
			timer: 0,
			hasResult: false,
			success: false,
			errorMessage: "",
			show: null
		};
	},
	created: function () {
		document.addEventListener('click', this.hideResultOnClickOff);

		this.$request
			.setModeComponent()
			.setOption({
				componentName: this.componentName,
				action: "search",
			})
	},
	beforeDestroy() {
		document.removeEventListener('click', this.hideResultOnClickOff)
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("CT_BST_SEARCH_");
		}
	},
	methods: {
		onSearchChange: function (event) {
			if (this.query.length <= this.minLength) {
				if (this.query.length == 0) {
					this.hasResult = false;
				}

				return;
			}

			this.delay(() => {
				this.onSubmit(true);
			}, 250);
		},
		delay: function (callback, ms) {
			clearTimeout(this.timer);
			this.timer = setTimeout(callback, ms);
		},
		onFocus: function (e) {
			this.show = true;
			BX.onCustomEvent('Citrus.SearchTitle:focus');
		},
		hideResultOnClickOff: function (e) {
			if (this.$el.contains(e.target) || null === this.show) {
				return;
			}

			this.show = false;
			BX.onCustomEvent('Citrus.SearchTitle:focusout');
		},
		onSubmit: function (isAjax = false) {
			if (this.query.length === 0) {
				this.hasResult = false;
				this.errorMessage = this.loc.CT_BST_SEARCH_EMPTY;
				return;
			}

			this.errorMessage = "";

			if (this.query.length <= this.minLength) {
				this.hasResult = false;
				return;
			}

			if (!isAjax) {
				location.href = BX.util.add_url_param(this.params.formAction, {q: this.query});
			}

			this.loading = true;

			this.$request
				.setSignedParameters(this.signedParameters)
				.setData({
					ajax_call: 'y',
					INPUT_ID: this.params.inputId,
					q: this.query,
					l: this.params.minQueryLen
				})
				.send()
				.then(
					(response) => {
						if (!response) {
							return false;
						}

						this.resultPage = response.result_page;
						this.result = {
							product: response.product,
							other: response.other,
						};

						this.hasResult = true;
						this.success = this.result.length > 0;
					},
					(error) => {
						let message = error.length > 0 ? error : this.loc.AUTH_UNKNOWN_ERROR_MESSAGE;
						this.$dialog.alert(message, {html: true});
					}
				)
				.finally(() => {
					setTimeout(() => this.loading = false, 500);
				})
			;
		},
		onClearResult: function () {
			this.hasResult = false;
			this.query = "";
		},
	}
};

export default {SearchTitle};
